/* ------------------------------------------------------------------------
Copyright (c) 2016, VoiceVibes, Inc

VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
All contents of this file are proprietary and confidential. No part of
any of the contents of this file may be disclosed in any manner to
a third party without the prior written consent of VoiceVibes, Inc.
Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */

<template>
  <div
    v-if="permitted"
    class="col-lg-12"
  >
    <form @submit.prevent="save">
      <h2>
        Assign This
      </h2>

      <br>

      <label
        class="radioLabel"
      >
        <input
          v-model="assignmentType"
          type="radio"
          value="continuous"
        >
        Continuous
      </label>
      <div class="explanatory-text">
        Continuous assignments will be assigned to all current and<br>
        future users in the group
      </div>
      <br>
      <label
        class="radioLabel"
      >
        <input
          v-model="assignmentType"
          type="radio"
          value="single"
        >
        Non-Continuous
      </label>
      <div class="explanatory-text">
        Non-Continuous assignments will not be automatically assigned to new<br>
        users who join the group
      </div>

      <br><br>

      <div
        class="group-user-selection form-group"
      >
        <span
          v-if="assignmentType === 'single'"
          class="groupUserLabel"
        >
          Select one or more groups or users
        </span>
        <span
          v-if="assignmentType === 'continuous'"
          class="groupUserLabel"
        >
          Select one or more groups
        </span>
        <group-user-select
          :groups="managedGroups"
          :users="groupSpeakers"
          :mode="(assignmentType === 'continuous') ? 'group' : 'userAndGroup'"
          :multiple="true"
          @groupUserChange="groupUserChange"
        />
      </div>
      <div class="help-block">
        <p
          v-if="userError === 1"
          class="text-danger"
          role="alert"
        >
          You must select at least one group or user to assign this assignment.
        </p>
        <p
          v-if="userError === 2"
          class="text-danger"
          role="alert"
        >
          The group(s) you selected do not contain any speakers.
          Please either create a Continuous Assignment for the desired group
          or add speakers to a group before creating a Non-Continuous Assignment.
        </p>
      </div>
      <br><br>
      <button
        type="button"
        class="btn clear-btn"
        @click="$router.push({name: 'coach-dashboard'})"
      >
        Cancel / Return to Dashboard
      </button>
      <loading-button
        style="float:right"
        :loading="saving"
      >
        Save and Continue
      </loading-button>
    </form>
  </div>
</template>

<style lang="less" scoped>
  .radioHeader {
    font-size: 14px;
    font-weight: 600;
  }
  .radioLabel {
    font-size: 14px;
    font-weight: 400;
  }
  div.explanatory-text {
    padding-left: 17px;
    font-size: 11px;
    font-weight: 400;
    color: #999;
  }
  .groupUserLabel {
    padding: 5px 5px 9px 5px;
  }
  .group-user-selection {
    width: 80%;
  }
</style>
<script>
import GroupUserSelect from '../specials/GroupUserSelect';
import AssignmentDataStructures from '../specials/AssignmentDataStructures';
import ScorecardMixin from '../specials/ScorecardMixin';

export default {
  components: { GroupUserSelect },
  mixins: [AssignmentDataStructures, ScorecardMixin],
  props: [ 'assignment' ],
  data() {
    return {
      assignmentType: 'continuous',
      checkboxValue: 'left',
      userError: false,
      permitted: false,
      saving: false,
      selected: null,
      rawAssignments: null,
    };
  },
  computed: {
    managedGroups: {
      cache: false,
      get() {
        return this._.filter(this.$store.getters.activeGroups, group => {
          return this._.includes(group.roles, 'manager');
        });
      }
    },
    groupSpeakers: {
      cache: false,
      get() {
        const speakers = {};
        for (let groupId in this.$store.getters.groupMembers) {
          speakers[groupId] = {};
          this._.forEach(
            this.$store.getters.groupMembers[groupId],
            (u) => {
              if (u && u.roles && u.roles.indexOf('speaker') !== -1) {
                speakers[groupId][u.userId] = u;
              }
            }
          );
        }
        return speakers;
      }
    },
    preferences() {
      return this.$store.getters.preferences;
    },
  },
  created() {
    if (this.assignment.userTargets.length || this.assignment.groupTargets.length) {
      // Do not allow editing of existing assignments
      return this.$emit('advanceAssignmentEditor');
    }
    this.permitted = true;
  },
  methods: {
    groupUserChange(options) {
      if (!options) return;

      if (options.length) {
        this.rawAssignments = options;
      } else {
        this.rawAssignments = [ options ];
      }
    },
    save() {
      this.userError = false;
      if (!this.rawAssignments || !this.rawAssignments.length) {
        // The user must pick something
        return this.userError = 1;
      }

      // First, deduplicate rawAssignments
      const groupAssignments = _.filter(this.rawAssignments, {type: 'group'});
      const rawAssignments = _.filter(this.rawAssignments, (ass) => {
        if (ass.type === 'group') return true;
        return !_.find(groupAssignments, {groupId: ass.groupId});
      });

      // Second, convert rawAssignments into this format:
      // { $groupId: { targets: [id, id], type: user|group, groupId } }
      let targets = {};
      _.map(rawAssignments, (a) => {
        if (!a.id) return; // a bit of validation
        if (!targets[a.groupId]) {
          targets[a.groupId] = {
            type: a.type,
            targets: [],
            groupId: a.groupId,
          };
        }
        if (a.type === 'user' || this.assignmentType === 'continuous') {
          // User targets and continuous groups are straightforward
          return targets[a.groupId].targets.push(a.id);
        }
        // Group targets for single assignments need to be expanded
        // Also, mark it as the correct type
        targets[a.groupId].type = 'user';

        let foundSomeone1 = false;
        _.map(this.groupSpeakers, (group, groupId) => {
          if (groupId !== a.groupId) return;
          _.map(group, (user) => {
            foundSomeone1 = true;
            targets[a.groupId].targets.push(user.userId);
          });
        });
        // If they added an empty group, remove it
        if (!foundSomeone1) {
          delete targets[a.groupId];
        }
      });

      // Third, validate targets to make sure they didn't pick only empty groups
      let foundSomeone2 = false;
      _.forEach(targets, (t) => {
        if (t.targets.length) foundSomeone2 = true;
      });
      if (!foundSomeone2) {
        return this.userError = 2;
      }

      // Lastly, save it
      this.saving = true;
      let promises = [];
      _.forEach(targets, (targetObj) => {
        promises.push(
          this.getAssignmentSavePromises(
            targetObj.targets,
            targetObj.type,
            {groupId: targetObj.groupId}
          )
        );
      });
      window.Promise.all(promises).then(() => this.$emit('advanceAssignmentEditor'));
    },
  }
};
</script>
